import { Component, OnInit } from '@angular/core'
import { Form }   from '@angular/forms'
import { Router } from "@angular/router"
import { UserService } from '../user.service'

@Component({
	selector: 'app-user-login',
	templateUrl: './user-login.component.html',
	styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit {
	username_input: string
	username_available: boolean = true
	emailregistration = {
		email: null,
		password: null,
	}

	constructor(
		public user: UserService,
		public router: Router,
	) { }

	ngOnInit() {
		this.username_input = this.user.current ? this.user.current.username : ''
		// console.log(this.user.logged_in, this.user.current)

		this.user.get.subscribe(user => {
			// console.log(user)
			if (this.user.logged_in && this.user.current && this.user.current.username) {
				this.router.navigate(['/dashboard'])
			}
		})
	}

	checkUsername(e) {
		this.username_input = e.target.value
		this.user.checkUsername(this.username_input).subscribe(user => {
			this.username_available = user ? false : true
		})
		// this.user.getUserWithUsername(this.username_input).forEach((snapshot) => {
		//	 this.username_available = this.user.current.username == this.username_input || snapshot.length === 0
		// })
	}

	updateUsername() {
		if (this.username_available) {
			this.user.addUserName(this.username_input)
			// this.user.current.username = this.username_input
		}
	}

	emailLogin() {
		this.user.emailLogin(this.emailregistration.email, this.emailregistration.password)
	}

	ngOnDestroy() {
		this.user.cleanErrors()
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user-login/user-login.component.ts